import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE, SIGN_IN_REQUEST, SIGN_IN_SUCCESS, SIGN_IN_FAILURE, SIGN_OUT_SUCCESS } from '../actions/actionTypes';

const initialState = {
  user: (() => {
    try {
      const userData = localStorage.getItem("userData");
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      return null; 
    }
  })(),
  loading: false,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGNUP_REQUEST:
      return { ...state, loading: true, error: null };
    case SIGNUP_SUCCESS:
    
      return { ...state, loading: false, user: action.payload.data.data };
    case SIGNUP_FAILURE:
      return { ...state, loading: false, error: action.payload };



    case SIGN_IN_REQUEST:
      return {...state, loading: true, error: null};
    case SIGN_IN_SUCCESS:
     
      return {...state, loading: false, user: action.payload.data}
    case SIGN_IN_FAILURE:
      return {...state, loading: false, error: action.payload}
      case SIGN_OUT_SUCCESS:
        return { ...state, user: null, error: null };
    default:
      return state;
  }
};

export default authReducer;
